const Sort = {
    string(list, propName, reverse){
        list.sort(function(itemA, itemB){
            let strA = (itemA && itemA[propName]) ? itemA[propName] : "";
            let strB = (itemB && itemB[propName]) ? itemB[propName] : "";
            if(strA === "")
                return 1;
            if(strB === "")
                return -1;
            if (strA.toLowerCase() < strB.toLowerCase())
                return -1;
            if (strA.toLowerCase() > strB.toLowerCase())
                return 1;
            return 0;
        });
        if(reverse)
            list.reverse();
    },
    number(list, propName, reverse){
        list.sort(function(itemA, itemB){
            let numA = (itemA && itemA[propName]) ? itemA[propName] : 0;
            let numB = (itemB && itemB[propName]) ? itemB[propName] : 0;
            if(numA === 0)
                return 1;
            if(numB === 0)
                return -1;
            if (numA < numB)
                return -1;
            if (numA > numB)
                return 1;
            return 0;
        });
        if(reverse)
            list.reverse();
    },
    date(list, reverse){
        list.sort(function(itemA, itemB){
            let dateA = (itemA) ? parseInt(itemA.date) : 0;
            let dateB = (itemB) ? parseInt(itemB.date) : 0;
            if (dateA < dateB)
                return -1;
            if (dateA > dateB)
                return 1;
            let numA = (itemA && itemA.updated_on) ? itemA.updated_on : 0;
            let numB = (itemB && itemB.updated_on) ? itemB.updated_on : 0;
            if(numA === 0)
                return 1;
            if(numB === 0)
                return -1;
            if (numA < numB)
                return -1;
            if (numA > numB)
                return 1;
            return 0;
        });
        if(reverse)
            list.reverse();
    },
    notes(list, reverse){
        this.string(list, "notes", reverse);
    },
    hasAttachment(list, reverse){
        this.string(list, "attachmentCls", reverse);
    },
    isRecurring(list, reverse){
        this.string(list, "recurringCls", reverse);
    },
    amount(list, reverse){
        this.number(list, "amount", reverse);
    },
    updated_on(list, reverse){
        this.number(list, "updated_on", reverse);
    },
    type_tag(list, reverse){
        this.string(list, "typeName", reverse);
    },
    tag_type(list, reverse){
        this.string(list, "tagStr", reverse);
    },
    name(list, reverse){
        this.string(list, "name", reverse);
    }
}

module.exports = Sort;


// WEBPACK FOOTER //
// ./src/control/util/Sort.js